import { createContext } from 'react';
import logger from '../../app/middleware/log';

export const NavbarContext = createContext({ setMenuPosition: (menuPosition: string) => { logger.log('setting menu position') } });